import { Link } from "react-router-dom";
import { Info } from "lucide-react";

export default function PremiumCancel() {
  return (
    <div data-testid="premium-cancel" className="max-w-lg mx-auto px-6 py-24 text-center">
      <Info className="w-10 h-10 mx-auto mb-4" style={{ color: "var(--wofy-primary)" }} />
      <h1 className="font-display text-3xl mb-2">No charge — you're all set.</h1>
      <p className="text-sm" style={{ color: "var(--wofy-text-soft)" }}>
        We didn't collect any payment. You can come back to the pricing page any time.
      </p>
      <div className="mt-6 flex justify-center gap-2">
        <Link to="/pricing" className="wofy-btn-primary">Back to pricing</Link>
        <Link to="/" className="wofy-btn-ghost">Back home</Link>
      </div>
    </div>
  );
}
